export const queryKeys = {
  exchangeRate: "exchange-rate",
};
